import { useState, useRef } from 'react';
import axios from 'Axios';
import { api, toastify } from 'Utils';
import { Edit, X } from 'tabler-icons-react';
import { ModalBox, Button, SubmitButton } from 'Elements';
import { clx, fileType } from 'Utils';
import styles from 'partials/modalbox/modal-form.module.scss';
import contentStyles from 'partials/dashboard/user-content.module.scss';

export const ModalBoxEditContent = ({ isOpen, onClose, size, story }) => {
	console.log('story: ', story);
	const [state, setState] = useState({
		fields: {
			title: '',
			body: '',
			description: ''
		},
		fileUploaded: { name: story?.file_url?.origin },
		isSubmiting: false,
		errors: []
	});
	const fileInput = useRef(null);

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const clearSelected = () => {
		fileInput.current.value = null;
		setState((prev) => ({
			...prev,
			fileUploaded: {}
		}));
	};

	const handleUpload = () => {
		fileInput.current.click();
	};

	const handleChange = (e) => {
		const fileUploaded = e.target.files[0];
		setState((prev) => ({
			...prev,
			fileUploaded
		}));
	};

	const submitForm = () => {
		const data = {
			title: state.fields.title,
			description: state.fields.description,
			production_id: story.id,
			...(story?.file_id && { file_id: story.file_id }),
			content_type: story.type,
			file_type: story.type,
			file: state.fileUploaded
		};

		const formData = new FormData();
		for (const field in data) {
			formData.append(field, data[field] ?? '');
		}
		setState((prev) => ({
			...prev,
			isSubmiting: true
		}));
		axios.post(api.updateStory, data).then((res) => {
			const data = res.data;
			setState((prev) => ({
				...prev,
				isSubmiting: false
			}));
			if (data.success) {
				onClose?.();
				toastify(
					<p>
						ویرایش {fileType[story.type].title} با موفقیت انجام شد
					</p>,
					'success'
				);
			}
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	return (
		<ModalBox isOpen={isOpen} onClose={onClose} size={size}>
			<header className={styles.header}>
				<h3 className={styles.headerTitle}>{`ویرایش ${
					fileType[story.type].title
				}`}</h3>
			</header>
			<div className={styles.body}>
				<div className={contentStyles.selectedBox}>
					<Edit
						size="36"
						color="#838794"
						strokeWidth={1.5}
						className={contentStyles.selectedIcon}
					/>
					<div className={contentStyles.body}>
						<h3 className={contentStyles.selectedTitle}>
							عنوان محتوا
						</h3>
						<span
							className={clx(
								contentStyles.textOverflow,
								contentStyles.selectedText
							)}>
							{story.story.title}
						</span>
					</div>
				</div>
				<form className={styles.form} onSubmit={handleSubmit}>
					<div className={styles.fieldset}>
						<label htmlFor="title" className={styles.label}>
							عنوان
						</label>
						<input
							id="text"
							type="text"
							name="title"
							placeholder={`عنوان ${fileType[story.type].title}`}
							defaultValue={story?.title}
							className={styles.input}
							onChange={handleInput}
						/>
					</div>
					{story.type === 'text' && (
						<div className={styles.fieldset}>
							<label htmlFor="body" className={styles.label}>
								متن
							</label>
							<textarea
								id="body"
								name="body"
								placeholder="متن کامل"
								col="20"
								rows="20"
								defaultValue={story?.body}
								className={[
									styles.input,
									styles.inputLong
								].join(' ')}
								onChange={handleInput}
							/>
						</div>
					)}
					{(story.type === 'image' ||
						story.type === 'video' ||
						story.type === 'sound') && (
						<div className={styles.fieldset}>
							<Button
								className={[
									styles.btnBorder,
									styles.btnFull
								].join(' ')}
								onClick={handleUpload}>
								{`انتخاب فایل ${fileType[story.type].title}`}
							</Button>
							<div className={styles.fieldRow}>
								<input
									hidden
									ref={fileInput}
									type="file"
									multiple={false}
									accept={fileType[story.type].accept}
									style={{ display: 'none' }}
									onChange={handleChange}
								/>
								{state.fileUploaded?.name && (
									<div
										className={[
											styles.fieldBox,
											'mt-10',
											styles.input_ltr
										].join(' ')}>
										<span
											className={[
												styles.text,
												styles.ellipsis
											].join(' ')}
											title={state.fileUploaded?.name}>
											{state.fileUploaded?.name}
										</span>
										<Button
											title="حذف فایل"
											className={styles.removeSelected}
											onClick={clearSelected}>
											<X size="14" />
										</Button>
									</div>
								)}
							</div>
						</div>
					)}
					<div className={styles.fieldset}>
						<label htmlFor="description" className={styles.label}>
							توضیحات
						</label>
						<textarea
							id="description"
							name="description"
							placeholder={`اگر ${
								fileType[story.type].title
							} دارای راوی یا توضیحات خاصی می باشد در این قسمت درج نمایید`}
							col="20"
							rows="10"
							defaultValue={story?.description}
							className={[styles.input, styles.inputShort].join(
								' '
							)}
							onChange={handleInput}
						/>
					</div>
					<div className={styles.fieldset}>
						<SubmitButton
							disabled={state.isSubmiting}
							className={clx(styles.submit, styles.submitFull)}
							title={`ویرایش ${fileType[story.type].title}`}
						/>
					</div>
				</form>
			</div>
		</ModalBox>
	);
};
